import { FicheAutoControleCritere } from "../../store/types/FicheAutocontrole.Types";
import { ModeAffichage } from "../../utils/constantes/contantes";
import { TabSynthese } from "../../store/types/TabSynthese.Types";

interface PropsFromDispatch {
    tabSynthese: TabSynthese;
}

/**
 * Classe utilitaire pour un @FicheAutoControleCritere
 */
export class CritereUtils {
    /**
     * Détermine si un critère est actif en fonction du mode d'affichage et des données de synthèse.
     * @param critere Le critère à évaluer.
     * @param mode Le mode d'affichage.
     * @param tabSynthese Les données de synthèse (optionnelles).
     * @returns true si le critère est actif, false sinon.
     */
    static getActiveStateFromCriteria(
        critere: FicheAutoControleCritere,
        mode?: ModeAffichage,
        tabSynthese?: TabSynthese
    ): boolean {
        if (mode === ModeAffichage.SYNTHESE) {
            const isSyntheseAutocontroleL = tabSynthese?.infosGenerales?.typeAutocontrole === "L";
            return isSyntheseAutocontroleL ? critere.active : false;
        }
        return critere.active;
    }

    /**
     * Variante simplifiée pour les cas où les données de synthèse ne sont pas nécessaires.
     * @param critere Le critère à évaluer.
     * @param mode Le mode d'affichage.
     * @returns true si le critère est actif, false sinon.
     */
    static getActiveStateFromCriteriaTab(
        critere: FicheAutoControleCritere,
        mode?: ModeAffichage
    ): boolean {
        return mode === ModeAffichage.SYNTHESE ? false : critere.active;
    }
}

